import React, { useState } from 'react';
import './RowsPerPageDropdown.css';
interface RowsPerPageDropdownProps {
    label: string;
    options: number[];
    onSelect: (value: number) => void;
}
 
const RowsPerPageDropdown: React.FC<RowsPerPageDropdownProps> = ({ label, options, onSelect }) => {
    const [selectedOption, setSelectedOption] = useState<number | null>(null);
 
    const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = Number(event.target.value);
        setSelectedOption(value);
        onSelect(value);
    };
 
    return (
        <div className='rows_per_page_dropdown_main' >
            <span className='rows_per_page_dropdown_label'>{label}</span>
            <select className='rows_per_page_dropdown' value={selectedOption ?? ''} onChange={handleSelect}>
                {options.map(option => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </select>
        </div>
    );
};
 
export default RowsPerPageDropdown;